// 3rd party libs
import React from 'react';
import cx from 'classnames';

// local modules
import styles from './Divider.module.scss';

type TDivider = {
  className?: string;
};

const Divider: React.FC<TDivider> = ({ className }) => {
  return <hr className={cx(styles.divider, className)} />;
};

export default Divider;
